import useDropUnsupportedVehicle from '../../hooks/useDropUnsupportedVehicle/useDropUnsupportedVehicle';

// Renders nothing: drops vans (buses, chassis cabs) a visitor chose before
// the shop stopped listing them. See useDropUnsupportedVehicle.
const UnsupportedVehicleGuard = () => {
  useDropUnsupportedVehicle();

  return null;
};

export default UnsupportedVehicleGuard;
